import React from 'react';
import { Activity, Shield, Zap, Brain, Users, User } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
export default function LongevitySolutions() {
  const longevityServices = [];
  return <section className="py-16 bg-background">
      <div className="container">
        <div className="text-center mb-12">
          
          
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {longevityServices.map((service, index) => {
          const IconComponent = service.icon;
          return <Card key={index} className="card hover-lift border border-muted-light shadow-soft bg-white rounded-md">
                <CardHeader className="pb-4">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="flex items-center justify-center w-10 h-10 rounded-sm bg-primary-light-bg">
                      <IconComponent className="w-5 h-5 text-primary" />
                    </div>
                  </div>
                  <CardTitle className="text-xl font-medium text-foreground leading-snug">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-sm text-muted-dark leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}